import React from 'react';
import { Field } from 'react-final-form';
import NumberInput from '../NumberInput';

const NumberField = ({
  name,
  validate,
  showErrorMessage = true,
  controlledValue = false,
  onChange = (value) => value,
  ...restProps
}) => (
  <Field
    name={name}
    validate={validate}
    render={({ input, meta }) => (
      <NumberInput
        {...input}
        {...restProps}
        onChange={(value) => (controlledValue ? onChange(value) : input.onChange(onChange(value)))}
        error={meta.touched && meta.error && (showErrorMessage ? meta.error : ' ')}
      />
    )}
  />
);

export default NumberField;
